import React, { useEffect } from 'react';
import styles from './infoAnimation.module.css';

/**
 * InfoAnimation Component
 * 
 * A premium success animation component.
 * 
 * @param {Object} props
 * @param {string} props.message - The text to display below the animation.
 * @param {number} props.duration - How long to show the animation (in ms) before calling onClose. Default 2500ms.
 * @param {function} props.onClose - Callback triggered after duration.
 */
const InfoAnimation = ({ message = "Sucesso!", duration = 2500, onClose }) => {
    
    useEffect(() => {
        if (onClose) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [onClose, duration]);

    return (
        <div className={styles.overlay}>
            <div className={styles.card}>
                <div className={styles.animationWrapper}>
                    <div className={styles.ring}></div>
                    <div className={styles.sparkle} style={{'--i': 1}}></div>
                    <div className={styles.sparkle} style={{'--i': 2}}></div>
                    <div className={styles.sparkle} style={{'--i': 3}}></div>
                    <div className={styles.sparkle} style={{'--i': 4}}></div>
                    <div className={styles.sparkle} style={{'--i': 5}}></div>
                    <div className={styles.successCircle}>
                        <svg 
                            className={styles.thumbsUp} 
                            viewBox="0 0 24 24"
                            fill="currentColor"
                        >
                            <path d="M21.5,9H17.2l0.8-3.9c0.2-1.2-0.7-2.4-2-2.4c-0.6,0-1.2,0.3-1.6,0.7L9,9H5c-1.1,0-2,0.9-2,2v8c0,1.1,0.9,2,2,2h11.1 c0.9,0,1.7-0.6,1.9-1.4l2.9-7.1C22.2,11.4,22.4,10.2,21.5,9z M6,21H4v-11h2V21z" />
                        </svg>
                    </div>
                </div>
                <div className={styles.message}>
                    {message}
                </div>
            </div>
        </div>
    );
};

export default InfoAnimation;
